import React, { useState, useEffect } from "react";
import moment from "moment";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import {
  BarChart,
  Bar,
  // Cell,
  XAxis,
  YAxis,
  LabelList,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import TabPanel from "../../../components/TabPanel";

moment.locale("en");

function Bulanan({ value }) {
  const { profil } = useData();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getMonthlyTransaksiSeller");
      const res = await func({ user_id: profil.id });
      setData(res?.data ?? []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <TabPanel value={value} index="bulanan">
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month_year" />
          <YAxis />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en').format(value)} />
          <Legend />
          <Bar dataKey="total_komisi" fill="#8884d8">
          <LabelList
              dataKey="total_komisi"
              position="top"
              formatter={(value) => new Intl.NumberFormat("en").format(value)}
            />
          </Bar>
          <Bar dataKey="total_sales" fill="#82ca9d">
          <LabelList
              dataKey="total_sales"
              position="top"
              formatter={(value) => new Intl.NumberFormat("en").format(value)}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </TabPanel>
  );
}

export default Bulanan;
